// import { logEvent } from '@firebase/analytics';
// import { firebaseAnalytics } from '../firebase';
import getTimezone from '../timezone';
import { queueReportExpose } from './reportQueue';
import type { EBiz } from './report_biz';
import type { ReportKeys } from './type';

// 通过 枚举 限定上报的 key，方便管理
// 必须在此文档记录：https://mindverse.feishu.cn/sheets/DoVIsBeBVhdtiFtZZgVcWbVanXh
export enum EReportExposeKey {
  show_ability_panel = 'ability_config_expose',

  login_expose = 'login_expose',
  oauth_expose = 'oauth_expose',
  pa_create_start = 'pa_create_start',
  pa_create_expose = 'pa_create_expose',

  memory_expose = 'memory_expose',
  sharing_evoked_expose = 'sharing_evoked_expose',

  topic_suggestion_expose = 'topic_suggestion_expose',

  talk_share_cover_expose = 'talk_share_cover_expose',

  ai_home_expose = 'ai_home_expose',
  circle_expose = 'circle_expose',
  talk_invite_expose = 'talk_invite_expose',
  snap_invite_expose = 'snap_invite_expose',
  invite_expose = 'invite_expose',
  talk_share_expose = 'talk_share_expose',
  snap_share_expose = 'snap_share_expose'
}

export default function reportExpose(key: EReportExposeKey, params?: ReportKeys, biz?: EBiz): void {
  const searchParams = new URLSearchParams(window.location.search);
  const timezone = getTimezone();

  // 为了以防万一，默认使用 key10 填写 biz 的值，防止被占用
  const newParams: ReportKeys = {
    key10: biz,
    ...(timezone ? { timezone } : {}),
    ...(searchParams.get('utm_source')
      ? { utm_source: searchParams.get('utm_source') || undefined }
      : {}),
    ...(searchParams.get('utm_medium')
      ? { utm_medium: searchParams.get('utm_medium') || undefined }
      : {}),
    ...(searchParams.get('utm_campaign')
      ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
      : {}),
    ...(params || {})
  };

  queueReportExpose(key, newParams);
  // logEvent(firebaseAnalytics(), key as string, newParams);
}
